import { render, staticRenderFns } from "./CampaignsProducts.vue?vue&type=template&id=fbfa33ee"
import script from "./CampaignsProducts.vue?vue&type=script&lang=js"
export * from "./CampaignsProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports